import "@/configs/i18next";
import "@/configs/dayjs";
import "@/configs/yup";
import "@/configs/hotjar";
import "@/configs/sentry";
import "leaflet/dist/leaflet.css";

import { App as AntDesignApp, ConfigProvider } from "antd";
import * as echarts from "echarts/core";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IconContext } from "react-icons";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import { useAntLocale, useGetAntTheme, useGetMyTheme } from "./App.hooks";
import ReactQueryWrapper from "./components/ReactQueryWrapper";
import router from "./configs/router";
import { getDarkEchartsTheme } from "./configs/themes/echartsTheme/dark";
import { getLightEchartsTheme } from "./configs/themes/echartsTheme/light";
import { GlobalStyle } from "./GlobalStyle";
import { useColorScheme } from "./hooks/useColorScheme";
import { changeDayJsLocale } from "./utils/changeDayJsLocale";

function App() {
  const antTheme = useGetAntTheme();
  const myTheme = useGetMyTheme();
  const antLocale = useAntLocale();
  const { i18n } = useTranslation();
  const colorScheme = useColorScheme();

  const iconContextValue = useMemo(() => ({
    size: "16px",
    style: {
      verticalAlign: "middle",
    },
  }),
  []);

  useEffect(() => {
    changeDayJsLocale(i18n.language);
  }, [i18n.language]);

  // We can use these themes in our chart components
  useEffect(() => {
    echarts.registerTheme("dark", getDarkEchartsTheme(colorScheme));
    echarts.registerTheme("light", getLightEchartsTheme(colorScheme));
  }, [colorScheme]);

  return (
    <IconContext.Provider value={iconContextValue}>
      <ConfigProvider theme={antTheme} locale={antLocale}>
        <AntDesignApp message={{
          maxCount: 3,
        }}
        >
          <ThemeProvider theme={myTheme}>
            <GlobalStyle />
            <ReactQueryWrapper>
              <RouterProvider router={router} />
            </ReactQueryWrapper>
          </ThemeProvider>
        </AntDesignApp>
      </ConfigProvider>
    </IconContext.Provider>
  );
}

export default App;
